import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddRampModalComponent } from 'src/app/admin/components/modals/add-ramp-modal/add-ramp-modal.component';
import { DeleteRampModalComponent } from 'src/app/admin/components/modals/delete-ramp-modal/delete-ramp-modal.component';
import { EditRampModalComponent } from 'src/app/admin/components/modals/edit-ramp-modal/edit-ramp-modal.component';
import { Ramp } from 'src/app/admin/models/ramp.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { RampService } from 'src/app/admin/services/ramp.service';

@Component({
  selector: 'app-manage-ramps',
  templateUrl: './manage-ramps.page.html',
  styleUrls: ['./manage-ramps.page.scss'],
})
export class ManageRampsPage implements OnInit {
ramp: Ramp;
rooms=[];
paginationSettings = {totalItems: 0};
currentPage: number = 1;
ramps$ = this.rampService.ramp$;


  constructor(private modalController: ModalController, private rampService: RampService) { }

  ngOnInit():void {
    //this.rampService.getAllRamp();

    this.rampService.getAllRamp ({currentPage: 1, itemsPerPage: 100,
      ulaznaQuery: '', izlaznaQuery: '', brojRampeQuery: '',roomNameQuery:'',StatusQuery:''});
  }
  async openAddRampModal() {
    const modal = await this.modalController.create({
     component: AddRampModalComponent,
   /*   componentProps: {ramp: this.ramp}, */
     cssClass: 'medium-modal-css',
     backdropDismiss: true,
     swipeToClose: false,
   }); 

   await modal.present();
 }
 async openDeleteRampModal(ramp) {
   const modal = await this.modalController.create({
     component: DeleteRampModalComponent,
      componentProps: {ramp}, 
     cssClass: 'small-modal-css',
     backdropDismiss: true,
     swipeToClose: false,
   });
   await modal.present();
 }

 async openEditRampModal(ramp) {
   const modal = await this.modalController.create({
     component: EditRampModalComponent,
     componentProps: {ramp:{...ramp},rooms:this.rooms},
    cssClass: 'medium-modal-css',
     backdropDismiss: true,
     swipeToClose: false,
   });
   await modal.present();
 }



}
